import React, { Component } from 'react'
import './Footer.css'

export default class Footer extends Component {
  render() {
    return (
        <footer className="footer text-center">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <h5 className="text-center">
                            Download The Bolt App to Reap the Dividends of Democracy!
                        </h5>
                    </div>
                    <div className="col-6 offset-md-1 col-md-5">
                        <a href="https://171140.measurementapi.com/serve?action=click&publisher_id=171140&site_id=83620" >
                            <img src="https://bolt.eu/images/badges/app-store/en-5eb1a238.svg" alt="Get The App" style={{padding: "10px"}} className="img-fluid" />
                        </a>
                    </div>
                    <div className="col-6 col-md-5">
                        <a href="https://171140.measurementapi.com/serve?action=click&publisher_id=171140&site_id=81382">
                            <img src="https://bolt.eu/images/badges/play-store/en-d3afe83a.svg" alt="Get The App" className="img-fluid" />
                        </a>
                    </div>
                </div>
                <span className="secondary-text">© 2019 Bolt.</span>
            </div>
        </footer>
    )
  }
}
